angular.module('impactx.toolbar').component('ixMainToolbar', {
        controller: 'MainToolbarCtrl',
        templateUrl: 'shared/toolbar/templates/main-toolbar.html'
    }
);